import React, { useEffect } from 'react';

import { Trans } from '@lingui/react/macro';
import { useOktaAuth } from '@okta/okta-react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'PropTypes' is defined but never used.
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import OktaSignInWidget from './OktaSignInWidget/OktaSignInWidget';
import { loginChannel, useLogin } from './useLogin';

// Azure Active Directory Identity Provider IDs for Great Expression Dental
// Centers and Videa Test
const AAD_IDP_ID_GEDC = '0oap4y6mtcSucKcS95d7';
const AAD_IDP_ID_VIDEA = '0oabm5m7mjZu4xpwz5d7';

interface Props {
  config: {
    baseUrl: string;
    clientId: string;
    redirectUri: string;
    logo: string;
    i18n: {
      [key: string]: {
        'primaryauth.title': string;
      };
    };
    useClassicEngine: boolean;
    idps?: any;
    idpDisplay?: any;
    features?: any;
    idpDiscovery?: any;
    language?: string;
    assets?: {
      baseUrl: string;
    };
  };
}

const Login: React.FC<Props> = ({ config }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const { success } = useLogin();

  const onLoginSuccess = async (tokens: any) => {
    // Extract IdP info (if available in claims)
    const idToken = tokens.idToken;
    const idp = idToken?.claims?.idp || idToken?.claims?.idp_id;

    if (idp) {
      localStorage.setItem('idp', String(idp));
    }

    await success(tokens.accessToken.accessToken);
    loginChannel.postMessage('login');
    oktaAuth.handleLoginRedirect(tokens);
  };

  useEffect(() => {
    const lastIdp = localStorage.getItem('idp');

    if (
      lastIdp &&
      (lastIdp === AAD_IDP_ID_GEDC || lastIdp === AAD_IDP_ID_VIDEA) &&
      !authState?.isAuthenticated &&
      location.pathname !== '/login/callback'
    ) {
      oktaAuth
        .signInWithRedirect({
          idp: lastIdp,
          originalUri: window.location.href,
        })
        .catch((error) => {
          console.error('Error redirecting to login', error);
          localStorage.removeItem('idp');
        });
    }
  }, [authState?.isAuthenticated, oktaAuth]);

  if (!authState) {
    return (
      <div>
        <Trans>Loading...</Trans>
      </div>
    );
  }

  return (
    <div className="container bot" data-testid="okta-signin-widget">
      {authState.isAuthenticated ? (
        <Redirect to={{ pathname: '/' }} />
      ) : (
        <OktaSignInWidget config={config} onSuccess={onLoginSuccess} />
      )}
    </div>
  );
};

export default Login;
